import React, { useState } from "react";
import {
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table,
} from "reactstrap";
import { DayPrintSummary } from "../../../POS/BillPrint/page/DayPrintSummary";

const CloseSummaryPrint = ({ isOpen, toggle, data = [] }) => {
  const user = JSON.parse(localStorage.getItem("user"));
  console.log("🚀 ~ CloseSummaryPrint ~ user:", user);

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Day Close Summary</ModalHeader>
      <ModalBody>
        <Row className=" mb-3">
          <Col lg={8} className="text-end ">
            <h4 className="text-end ">{user?.organizationInfo?.name}</h4>
          </Col>
          <Col lg={4}>
            <div className="d-flex justify-content-end">
              <DayPrintSummary responseData={data} />
            </div>
          </Col>
        </Row>
        <h6>Closed by: {user?.user?.username}</h6>
        <Table bordered striped hover responsive>
          <thead>
            <tr>
              <th>#</th>
              <th>Payment Type</th>
              <th className="text-end">Total Amount</th>
            </tr>
          </thead>
          <tbody>
            {data?.length > 0 ? (
              data?.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.paymentTypeName}</td>
                  <td className="text-end">{item.totalAmount}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={3} className="text-center">
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </ModalBody>

    </Modal>
  );
};

export default CloseSummaryPrint;
